import { IconProps } from './types';

export const BasketIcon = ({ title = 'Basket Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="35" fill="none" viewBox="0 0 37 35" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            d="M1.542 16.333h33.916l-4.04 16.31A3.09 3.09 0 0 1 28.425 35H8.574a3.09 3.09 0 0 1-2.991-2.357z"
        ></path>
        <path
            fill="#0A2F73"
            d="M0 13.222c0-.43.345-.778.77-.778h35.46c.425 0 .77.349.77.778v3.111c0 .43-.345.778-.77.778H.77a.774.774 0 0 1-.77-.778z"
        ></path>
        <path
            fill="#fff"
            d="M10.792 22.556c0-.86.69-1.556 1.541-1.556.852 0 1.542.696 1.542 1.556v6.222c0 .859-.69 1.555-1.542 1.555a1.55 1.55 0 0 1-1.541-1.555zM16.958 22.556c0-.86.69-1.556 1.542-1.556.851 0 1.542.696 1.542 1.556v6.222c0 .859-.69 1.555-1.542 1.555a1.55 1.55 0 0 1-1.542-1.555zM24.667 21c-.852 0-1.542.696-1.542 1.556v6.222c0 .859.69 1.555 1.542 1.555.851 0 1.541-.696 1.541-1.555v-6.222c0-.86-.69-1.556-1.541-1.556"
        ></path>
        <path
            fill="#FB0"
            d="M16.577 2.58c.56-.647.496-1.63-.145-2.195a1.53 1.53 0 0 0-2.175.146L3.465 12.976c-.56.646-.496 1.629.145 2.195.64.565 1.615.5 2.175-.147zM20.423 2.58a1.565 1.565 0 0 1 .145-2.195c.64-.566 1.615-.5 2.175.146l10.792 12.445c.56.646.496 1.629-.145 2.195-.64.565-1.615.5-2.175-.147z"
        ></path>
    </svg>
);
